module.exports = __webpack_public_path__ + "img/Medical Book.b1a0c85.png";